import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import TrustStrip from '../components/TrustStrip';
import WhySection from '../components/WhySection';
import SelectionProcess from '../components/SelectionProcess';
import TipstersShowcase from '../components/TipstersShowcase';
import RecentResults from '../components/RecentResults';
import Pricing from '../components/Pricing';
import FaqSection from '../components/FaqSection';
import CtaBand from '../components/CtaBand';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <TipstersShowcase />
        <WhySection />
        <SelectionProcess />
        <RecentResults />
        <Pricing />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
    </>
  );
}
